export default "__VITE_ASSET__C8ZT6gOr__"